import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import logo from "./logo.svg";
import "./App.css";
import Navbar from "./components/layout/Navbar";
import Sidebar from "./components/layout/Sidebar";
import Articles from "./components/tables/ArticlesTable";
import Scripts from "./components/tables/ScriptsTable";
import { Box, Toolbar } from "@mui/material";
import Videos from "./components/tables/VideosTable";
import Login from "./pages/Login";
import { isAuthenticated } from "./utils/auth";

// Protected route component
const ProtectedRoute = ({ children }) => {
  if (!isAuthenticated()) {
    return <Navigate to="/login" />;
  }
  return children;
};

// Layout component that includes Navbar and Sidebar
const Layout = ({ children }) => (
  <Box sx={{ display: "flex" }}>
    <Navbar />
    <Sidebar />
    <Box
      component="main"
      sx={{
        flexGrow: 1,
        backgroundColor: "#f9f9f9",
        minHeight: "100vh",
      }}
    >
      <Toolbar />
      {children}
    </Box>
  </Box>
);

function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/login" element={<Login />} />

          <Route
            path="/"
            element={
              <ProtectedRoute>
                <Navigate to="/articles" />
              </ProtectedRoute>
            }
          />

          <Route
            path="/articles"
            element={
              <ProtectedRoute>
                <Layout>
                  <Articles />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/scripts"
            element={
              <ProtectedRoute>
                <Layout>
                  <Scripts />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/videos"
            element={
              <ProtectedRoute>
                <Layout>
                  <Videos />
                </Layout>
              </ProtectedRoute>
            }
          />

          {/* Catch-all route */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
